/* Floating social sidebar behaviour — mirrors frontend/web SocialSidebar. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ls-sidebar]');
  if (!root) return;

  var topBtn = root.querySelector('[data-ss-top]');
  var items = Array.prototype.slice.call(root.querySelectorAll('.ss-item'));
  var footer = document.querySelector('footer.footer');
  var footerContent = footer ? footer.querySelector('.footer__content-top') : null;
  var footerContentRight = 0;
  var active = null;
  var ticking = false;

  function clearActive() {
    if (active === null) return;
    Array.prototype.forEach.call(root.querySelectorAll('.ss-active'), function (el) {
      el.classList.remove('ss-active');
    });
    active = null;
  }

  /*
   * Only move out of the way when the sidebar would actually cover footer
   * links. The footer content is page-width while the sidebar hugs the viewport
   * edge, so on wide screens there is empty space beside the footer columns and
   * the sidebar can stay put all the way down. On narrow screens it would sit on
   * top of the footer, so hide it once the footer reaches it.
   */
  function measureFooterContent() {
    if (!footerContent) return;
    var nodes = footerContent.querySelectorAll('a, button, input, .footer-block__heading');
    var max = 0;
    Array.prototype.forEach.call(nodes, function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.width && rect.height && rect.right > max) max = rect.right;
    });
    footerContentRight = max;
  }

  function update() {
    if (topBtn) topBtn.hidden = window.scrollY <= 300;
    if (!footer) return;

    var rect = root.getBoundingClientRect();
    var footerRect = footer.getBoundingClientRect();
    var clearsFooter = rect.left >= footerContentRight + 8;
    var hidden = !clearsFooter && footerRect.top < rect.bottom + 8;

    items.forEach(function (item) {
      var label = item.querySelector('.ss-label') || item;
      var labelRect = label.getBoundingClientRect();
      var center = labelRect.top + labelRect.height / 2;
      item.classList.toggle(
        'ss-on-dark',
        center > footerRect.top && center < footerRect.bottom
      );
    });

    root.classList.toggle('ss-hidden', hidden);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      update();
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    measureFooterContent();
    onScroll();
  });
  measureFooterContent();
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      measureFooterContent();
      update();
    });
  }
  update();

  Array.prototype.forEach.call(root.querySelectorAll('[data-ss-popup]'), function (item) {
    item.addEventListener('click', function (e) {
      e.stopPropagation();
      var name = item.getAttribute('data-ss-popup');
      if (active === name) {
        clearActive();
        return;
      }
      clearActive();
      item.classList.add('ss-active');
      active = name;
    });
  });

  document.addEventListener('click', clearActive);

  if (topBtn) {
    topBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
})();
